import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { X, Plus } from "lucide-react";

const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// Reusable chip multi-select. Preset suggestions + optional custom entry.
export function TagSelect({ label, hint, values = [], onChange, options = [], allowCustom = true, testid = "tags" }) {
  const [input, setInput] = useState("");
  const add = (v) => {
    const t = String(v || "").trim();
    if (t && !values.includes(t)) onChange([...values, t]);
    setInput("");
  };
  const remove = (v) => onChange(values.filter((x) => x !== v));
  const suggestions = options.filter((o) => !values.includes(o));

  return (
    <div className="space-y-2" data-testid={testid}>
      <Label>{label}</Label>
      {hint && <p className="text-xs text-muted-foreground -mt-1">{hint}</p>}
      {values.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {values.map((v) => (
            <span key={v} className="inline-flex items-center gap-1.5 bg-[#09090B] text-white text-xs px-2 py-1" data-testid={`${testid}-chip-${slug(v)}`}>
              {v}
              <button type="button" onClick={() => remove(v)} data-testid={`${testid}-remove-${slug(v)}`} className="hover:text-white/70">
                <X className="h-3 w-3" />
              </button>
            </span>
          ))}
        </div>
      )}
      {allowCustom && (
        <div className="flex gap-2">
          <Input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(input); } }}
            placeholder="Type and press Enter to add…"
            className="bg-[#F4F4F5] border-black/10 rounded-none"
            data-testid={`${testid}-input`}
          />
          <Button type="button" variant="ghost" onClick={() => add(input)} className="rounded-none border border-black/10 shrink-0">
            <Plus className="h-4 w-4" />
          </Button>
        </div>
      )}
      {suggestions.length > 0 && (
        <div className="flex flex-wrap gap-1.5 pt-1">
          {suggestions.map((o) => (
            <button
              type="button"
              key={o}
              onClick={() => add(o)}
              data-testid={`${testid}-opt-${slug(o)}`}
              className="text-xs border border-black/10 px-2 py-1 text-muted-foreground hover:border-primary hover:text-[#09090B] transition-colors"
            >
              + {o}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
